import { SYSTEM_LOCALES } from './common.js';
import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
export const CAR_SOURCE_ENABLED_LOCALES_PREFERENCE = {
    scope: 'car-source',
    preferenceKey: 'enabled-locales',
};
const SYSTEM_LOCALE_SET = new Set(SYSTEM_LOCALES);
export function parseSystemLocaleList(value) {
    if (!Array.isArray(value))
        return null;
    if (value.some((locale) => typeof locale !== 'string' || !SYSTEM_LOCALE_SET.has(locale)) ||
        new Set(value).size !== value.length) {
        return null;
    }
    return [...value];
}
export function parseCarSourceEnabledLocalesPreference(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value))
        return null;
    return parseSystemLocaleList(value.enabledLocales);
}
export function resolveCarSourceEnabledLocales(input) {
    const shareLocales = parseSystemLocaleList(input.shareEnabledLocales);
    if (shareLocales?.length)
        return shareLocales;
    const tenantLocales = parseCarSourceEnabledLocalesPreference(input.tenantPreferenceValue);
    return tenantLocales?.length ? tenantLocales : [...SYSTEM_LOCALES];
}
export function resolveCarSourceEffectiveLocale(enabledLocales, requestedLocale) {
    return enabledLocales.includes(requestedLocale)
        ? requestedLocale
        : (enabledLocales[0] ?? SYSTEM_LOCALES[0]);
}
export const carSourceStockStatusEnum = createEnum({
    IN_STOCK: ['in_stock', '现车', 'green'],
    IN_TRANSIT: ['in_transit', '在途', 'blue'],
    FUTURE: ['future', '期车', 'orange'],
});
export const CAR_SOURCE_STOCK_STATUSES = enumValues(carSourceStockStatusEnum);
export const CAR_SOURCE_STOCK_STATUS_LABEL_MAP = enumLabelMap(carSourceStockStatusEnum);
export const carSourceVehicleConditionEnum = createEnum({
    NEW: ['new', '新车', 'blue'],
    USED: ['used', '二手车', 'default'],
});
export const CAR_SOURCE_VEHICLE_CONDITIONS = enumValues(carSourceVehicleConditionEnum);
export const CAR_SOURCE_VEHICLE_CONDITION_LABEL_MAP = enumLabelMap(carSourceVehicleConditionEnum);
export const carSourcePublishStatusEnum = createEnum({
    LISTED: ['listed', '在架', 'green'],
    DELISTED: ['delisted', '下架', 'default'],
});
export const CAR_SOURCE_PUBLISH_STATUSES = enumValues(carSourcePublishStatusEnum);
export const CAR_SOURCE_PUBLISH_STATUS_LABEL_MAP = enumLabelMap(carSourcePublishStatusEnum);
export const carSourceReviewStatusEnum = createEnum({
    REVIEWING: ['reviewing', '审核中', 'processing'],
    APPROVED: ['approved', '审核通过', 'success'],
    REJECTED: ['rejected', '审核拒绝', 'error'],
    AI_FAILED: ['ai_failed', 'AI 审核失败', 'warning'],
});
export const CAR_SOURCE_REVIEW_STATUSES = enumValues(carSourceReviewStatusEnum);
export const CAR_SOURCE_REVIEW_STATUS_LABEL_MAP = enumLabelMap(carSourceReviewStatusEnum);
export const CAR_SOURCE_ENTERPRISE_REVIEW_STATUSES = [
    carSourceReviewStatusEnum.REVIEWING,
    carSourceReviewStatusEnum.APPROVED,
    carSourceReviewStatusEnum.REJECTED,
];
export const carSourceReviewSourceEnum = createEnum({
    AI: ['ai', 'AI'],
    MANUAL: ['manual', '人工'],
});
export const CAR_SOURCE_REVIEW_SOURCES = enumValues(carSourceReviewSourceEnum);
export const CAR_SOURCE_REVIEW_SOURCE_LABEL_MAP = enumLabelMap(carSourceReviewSourceEnum);
export const carSourceReviewItemTypeEnum = createEnum({
    TEXT: ['text', '文字'],
    IMAGE: ['image', '图片'],
    VIDEO: ['video', '视频'],
    PDF: ['pdf', 'PDF'],
    EXTERNAL_LINK: ['external_link', '站外链接'],
});
export const CAR_SOURCE_REVIEW_ITEM_TYPES = enumValues(carSourceReviewItemTypeEnum);
export const CAR_SOURCE_REVIEW_ITEM_TYPE_LABEL_MAP = enumLabelMap(carSourceReviewItemTypeEnum);
export const carSourceExportMethodEnum = createEnum({
    FOB: ['FOB', 'FOB'],
    CIF: ['CIF', 'CIF'],
    EXW: ['EXW', 'EXW'],
    FCA: ['FCA', 'FCA'],
});
export const CAR_SOURCE_EXPORT_METHODS = enumValues(carSourceExportMethodEnum);
export const CAR_SOURCE_EXPORT_METHOD_LABEL_MAP = enumLabelMap(carSourceExportMethodEnum);
export const carSourceShareSortEnum = createEnum({
    DEFAULT: ['default', '默认排序'],
    EXPORT_PRICE_ASC: ['export_price_asc', '出口价从低到高'],
    EXPORT_PRICE_DESC: ['export_price_desc', '出口价从高到低'],
});
export const CAR_SOURCE_SHARE_SORTS = enumValues(carSourceShareSortEnum);
export const CAR_SOURCE_SHARE_SORT_LABEL_MAP = enumLabelMap(carSourceShareSortEnum);
export const carSourceAttachmentTypeEnum = createEnum({
    COVER: ['cover', '车辆封面照片'],
    DETAIL: ['detail', '车辆详情照片'],
    INSPECTION_REPORT: ['inspection_report', '检测报告'],
    VIDEO_INTRODUCTION: ['video_introduction', '视频介绍'],
});
export const CAR_SOURCE_COVER_ATTACHMENT_MAX_COUNT = 1;
export const CAR_SOURCE_DETAIL_ATTACHMENT_MAX_COUNT = 20;
export const CAR_SOURCE_INSPECTION_REPORT_ATTACHMENT_MAX_COUNT = 20;
export const CAR_SOURCE_VIDEO_INTRODUCTION_MAX_COUNT = 1;
export const CAR_SOURCE_VIDEO_INTRODUCTION_MAX_SIZE_BYTES = 500 * 1024 * 1024;
export const CAR_SOURCE_ATTACHMENT_MAX_COUNT = CAR_SOURCE_COVER_ATTACHMENT_MAX_COUNT +
    CAR_SOURCE_DETAIL_ATTACHMENT_MAX_COUNT +
    CAR_SOURCE_INSPECTION_REPORT_ATTACHMENT_MAX_COUNT +
    CAR_SOURCE_VIDEO_INTRODUCTION_MAX_COUNT;
export const CAR_SOURCE_ATTACHMENT_TYPES = enumValues(carSourceAttachmentTypeEnum);
export const CAR_SOURCE_ATTACHMENT_TYPE_LABEL_MAP = enumLabelMap(carSourceAttachmentTypeEnum);
//# sourceMappingURL=car-source.js.map